import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, CompassIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden texture-overlay bg-dark-parchment" data-id="element-92">
      {/* Decorative background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-burgundy-800/40 via-burgundy-950/80 to-burgundy-950 z-0" data-id="element-93"></div>

      {/* Subtle glowing orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-600/10 rounded-full blur-3xl" data-id="element-94"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-burgundy-600/20 rounded-full blur-3xl" data-id="element-95"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-12 md:py-24 text-center" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className="border-ornate p-8 md:p-16 bg-burgundy-950/60 backdrop-blur-sm relative" data-id="element-97">
          {/* Corner flourishes */}
          <div className="absolute top-2 left-2 w-8 h-8 border-t border-l border-gold-600/50" data-id="element-98"></div>
          <div className="absolute top-2 right-2 w-8 h-8 border-t border-r border-gold-600/50" data-id="element-99"></div>
          <div className="absolute bottom-2 left-2 w-8 h-8 border-b border-l border-gold-600/50" data-id="element-100"></div>
          <div className="absolute bottom-2 right-2 w-8 h-8 border-b border-r border-gold-600/50" data-id="element-101"></div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="flex justify-center mb-6" data-id="element-102">
            <span className="px-4 py-1 border border-gold-700/50 rounded-full text-gold-400 text-xs font-heading uppercase tracking-[0.2em] bg-gold-900/20 flex items-center gap-2" data-id="element-103">
              <SparklesIcon className="w-3 h-3" data-id="element-104" />
              The Premier Syndication Network
              <SparklesIcon className="w-3 h-3" data-id="element-105" />
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.8
        }} className="font-display text-5xl md:text-7xl lg:text-8xl text-parchment-100 mb-6 leading-tight" data-id="element-106">
            Where Fantasy Worlds <br data-id="element-107" />
            <span className="text-gold-500 text-shadow-gold italic" data-id="element-108">
              Find Their Audience
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7,
          duration: 0.8
        }} className="text-xl md:text-2xl text-parchment-200 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-109">
            Connecting fantasy and entertainment creators with devoted audiences
            across realms. Amplify your lore, monetize your magic, and build
            your legacy.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.9,
          duration: 0.8
        }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-110">
            <button className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold-600 to-gold-500 text-burgundy-950 font-heading font-bold uppercase tracking-widest hover:from-gold-500 hover:to-gold-400 transition-all shadow-gold-glow hover:shadow-gold-glow-lg flex items-center justify-center gap-3" data-id="element-111">
              <CompassIcon className="w-5 h-5" data-id="element-112" />
              Begin Your Chronicle
            </button>
            <button className="w-full sm:w-auto px-8 py-4 border border-gold-600 text-gold-500 font-heading font-bold uppercase tracking-widest hover:bg-gold-600/10 transition-all flex items-center justify-center gap-3" data-id="element-113">
              Explore the Network
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};